import { ReactNode } from "react"
import { IconRef } from "./Icon"
import { tv } from "@utils/tw"

export type DropdownButtonItem = {
  type: "item"
  disabled?: boolean
  onSelect?: (e: Event) => void
  textValue?: string
  label?: string | ReactNode
  icon?: IconRef
  className?: string
}

export type DropdownCheckboxItem = {
  type: "checkbox"
  checked?: boolean
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  label?: string | ReactNode
  className?: string
  textValue?: string
}

export type DropdownRadioGroupItemOption = {
  label: string | ReactNode
  value: string
}

export type DropdownRadioGroupItem = {
  type: "radio"
  value?: string
  onValueChange?: (value: string) => void
  label?: string | ReactNode
  disabled?: boolean
  options: {
    label: string | ReactNode
    value: string
    disabled?: boolean
  }[]
}

export type DropdownSubnavItem = {
  type: "subnav"
  label: string | ReactNode
  items: DropdownItem[]
}

export type DropdownSeparatorItem = {
  type: "separator"
}

export type DropdownHeadingItem = {
  type: "heading"
  label: string | ReactNode
}

export type DropdownItem =
  | DropdownButtonItem
  | DropdownCheckboxItem
  | DropdownRadioGroupItem
  | DropdownSubnavItem
  | DropdownSeparatorItem
  | DropdownHeadingItem

export const dropdownMenuStyles = tv({
  slots: {
    content: [
      "z-50",
      "bg-white shadow-popover outline-none text-primary",
      "radix-popover-animation",
      "min-w-[8rem] overflow-hidden",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      "p-1",
    ],
    items: "flex flex-col gap-[2px]",
    separator: "border-t border-primary/10 my-1",
  },
})

export const dropdownItemStyles = tv({
  base: "flex gap-2 items-center text-left outline-none p-2 data-[disabled]:opacity-50 data-[disabled]:!cursor-default",
  slots: {
    indicator: "flex-none size-[1.4em] el-svg:block el-svg:size-[1.4em] flex items-center justify-center",
    arrow: "flex-none size-[1.4em] el-svg:block el-svg:size-[1.4em] flex items-center justify-center",
    label: "flex-1 pr-2",
  },
  variants: {
    selectable: {
      true: {
        base: "data-[highlighted]:bg-primary data-[highlighted]:text-primary-foreground cursor-pointer",
        label: "type-ui-input",
      },
    },
    caption: {
      true: {
        base: "text-muted cursor-default",
        label: "type-ui-item-sm",
      },
    },
  },
  defaultVariants: {
    selectable: true,
  },
})
